import { render } from "./BaseFilter.vue?vue&type=template&id=d8d8ec8e"
import script from "./BaseFilter.vue?vue&type=script&lang=js"
export * from "./BaseFilter.vue?vue&type=script&lang=js"
script.render = render

export default script